    <header class="header">
        <div class="container">
            <div class="header-content">
                <div class="logo-nav">
                    <img src="logo.png" alt="Montage Connect" class="logo">
                    <!-- <nav class="nav">
                        <a *ngFor="let item of navigationItems" [routerLink]="item.route" class="nav-item"
                           >
                            <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
                            <span class="nav-text">{{ item.label }}</span>
                        </a>
                    </nav> -->

                    <!-- <nav class="nav">
                        <ng-container *ngFor="let item of navigationItems">
                          <div class="nav-item">
                            <a [routerLink]="item.route" (click)="item.children ? toggleSubmenu(item.label) : null">
                              <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
                              <span class="nav-text">{{ item.label }}</span>
                              <mat-icon *ngIf="item.children" class="arrow-icon">
                                {{ expandedItem === item.label ? 'expand_less' : 'expand_more' }}
                              </mat-icon>
                          </a>
                          <div *ngIf="expandedItem === item.label" class="submenu">
                              <a 
                                *ngFor="let subItem of item.children" 
                                [routerLink]="subItem.route" 
                                class="submenu-item"
                                [class.active]="isActive(subItem.route)"
                              >
                                <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                {{ subItem.label }}
                              </a>
                            </div>
                          </div>
                          
                        </ng-container>
                      </nav> -->


                      <nav class="nav" *ngIf="rbacNavReady">
                        <ul>
                          <li class="nav-item" *appHasPermission="deviceListMenuPermissions">
                            <a routerLink="/device-list">
                              <mat-icon>device_hub</mat-icon>
                              <span class="nav-text">DEVICES</span>
                            </a>
                          </li>
                          <li class="nav-item" *appHasPermission="RbacPermissions.Onboarding_Upload_DeviceXLSheet">
                            <a href="/onboarding">
                              <mat-icon>publish</mat-icon>
                              <span class="nav-text">ONBOARDING</span>
                            </a>
                          </li>
                          <li class="nav-item has-children" *appHasPermission="otaMenuPermissions">
                            <a routerLink="/ota/device-configuration-list">
                              <mat-icon>settings_input_antenna</mat-icon>
                              <span class="nav-text">OTA</span>
                            </a>
                            <ul class="submenu">
                              <li *appHasPermission="RbacPermissions.OTA_ConfigurationList_View"><a routerLink="/ota/device-configuration-list" [class.active]="active('/ota/device-configuration-list')"  class="submenu-item"><mat-icon class="submenu-arrow">chevron_right</mat-icon> Configuration List</a></li>

                              <li *appHasPermission="RbacPermissions.OTA_UploadConfigurationFile"><a routerLink="/ota/device-configuration-upload"  [class.active]="active('/ota/device-configuration-upload')" class="submenu-item"><mat-icon class="submenu-arrow">chevron_right</mat-icon> Upload Configuration File</a></li>

                              <li *appHasPermission="RbacPermissions.OTA_ConfigurationHistory_View"><a routerLink="/ota/device-configuration-history" [class.active]="active('/ota/device-configuration-history')"  class="submenu-item"><mat-icon class="submenu-arrow">chevron_right</mat-icon> Configuration History</a></li>

                            </ul>
                          </li>
                          <li class="nav-item has-children" *appHasPermission="userMgmtMenuPermissions">
                            <a routerLink="/user-management/customers">
                              <mat-icon>manage_accounts</mat-icon>
                              <span class="nav-text">USER MANAGEMENT</span>
                            </a>
                            <ul class="submenu">
                              <li *appHasPermission="RbacPermissions.UserMgmt_Customer_View">
                                <a routerLink="/user-management/customers" [class.active]="active('/user-management/customers')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  Customer Management
                                </a>
                              </li>
                              <li *appHasPermission="RbacPermissions.UserMgmt_Group_View">
                                <a routerLink="/user-management/group-management" [class.active]="active('/user-management/group-management')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  Group Management
                                </a>
                              </li>
                              <li *appHasPermission="RbacPermissions.UserMgmt_UserList_View">
                                <a routerLink="/user-management/user-list" [class.active]="active('/user-management/user-list')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  User List
                                </a>
                              </li>
                              <li *appHasPermission="RbacPermissions.UserMgmt_GroupAssignment">
                                <a routerLink="/user-management/customer-group-management" [class.active]="active('/user-management/customer-group-management')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  Customer Group Management
                                </a>
                              </li>
                              <li *appHasPermission="RbacPermissions.UserMgmt_RolePermission">
                                <a routerLink="/user-management/role-permission-management" [class.active]="active('/user-management/role-permission-management')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  Role &amp; Permission Management
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li class="nav-item has-children" *appHasPermission="tealMenuPermissions">
                            <a routerLink="/teal-integration/esim-info">
                              <mat-icon>integration_instructions</mat-icon>
                              <span class="nav-text">TEAL INTEGRATION</span>
                            </a>
                            <ul class="submenu">
                              <li *appHasPermission="RbacPermissions.TealInte_SIMInfo">
                                <a routerLink="/teal-integration/esim-info" [class.active]="active('/teal-integration/esim-info')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  SIM Info
                                </a>
                              </li>
                              <li *appHasPermission="RbacPermissions.TealInte_APILog">
                                <a routerLink="/teal-integration/api-log" [class.active]="active('/teal-integration/api-log')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  API Log
                                </a>
                              </li>
                              <li *appHasPermission="RbacPermissions.TealInte_OperationRes">
                                <a routerLink="/teal-integration/operation-results" [class.active]="active('/teal-integration/operation-results')" class="submenu-item">
                                  <mat-icon class="submenu-arrow">chevron_right</mat-icon>
                                  Operational Results
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </nav>
                      
                </div>
                <div class="profile-dropdown">
                    <div class="profile-toggle" (click)="toggleProfileMenu($event)">
                        <span class="profile_name">{{ getUserFullName() }}</span>
                        <span class="profile_icon"><mat-icon>person</mat-icon></span>
                        <span class="profile_arrow"><mat-icon>expand_more</mat-icon></span>
                    </div>
                    <div class="profile-menu" *ngIf="isProfileMenuVisible">
                        <!-- <a href="#">Profile</a> -->
                        <a (click)="logout()">Logout</a>
                    </div>
                </div>
            </div>
        </div>
    </header>

